export var VehicleAttributesSectionEnum;
(function (VehicleAttributesSectionEnum) {
    VehicleAttributesSectionEnum["TITLE"] = "Additional Vehicle ID";
})(VehicleAttributesSectionEnum || (VehicleAttributesSectionEnum = {}));
export var VehicleAttributeTypeEnum;
(function (VehicleAttributeTypeEnum) {
    VehicleAttributeTypeEnum["PIN_ATTRIBUTE"] = "pin";
    VehicleAttributeTypeEnum["NADA_ATTRIBUTE"] = "nada";
    VehicleAttributeTypeEnum["REDBOOK_ATTRIBUTE"] = "redbook";
})(VehicleAttributeTypeEnum || (VehicleAttributeTypeEnum = {}));
export const VehicleAttributeLabelEnumKey = new Map([
    [VehicleAttributeTypeEnum.PIN_ATTRIBUTE, 'PIN'],
    [VehicleAttributeTypeEnum.NADA_ATTRIBUTE, 'J.D. Power Values'],
    [VehicleAttributeTypeEnum.REDBOOK_ATTRIBUTE, 'Redbook']
]);
export const VehicleAttributeTooltipEnumKey = new Map([
    [
        VehicleAttributeTypeEnum.PIN_ATTRIBUTE,
        'PIN is used to determine the most accurate options and equipment packages'
    ],
    [
        VehicleAttributeTypeEnum.NADA_ATTRIBUTE,
        'J.D. Power Values is used to determine available vehicle equipment to calculate Approximate Cash Value of the vehicle'
    ],
    [
        VehicleAttributeTypeEnum.REDBOOK_ATTRIBUTE,
        'Redbook is used to determine available vehicle equipment to calculate Approximate Cash Value of the vehicle'
    ]
]);
export const VehicleAttributeDefaultOptionEnumKey = new Map([
    [VehicleAttributeTypeEnum.PIN_ATTRIBUTE, '--Select PIN--'],
    [VehicleAttributeTypeEnum.NADA_ATTRIBUTE, '--Select J.D. Power Values VID--'],
    [VehicleAttributeTypeEnum.REDBOOK_ATTRIBUTE, '--Select Redbook Control Number--']
]);
export const VehicleAttributeValueLabelEnumKey = new Map([
    [VehicleAttributeTypeEnum.PIN_ATTRIBUTE, 'pinVid'],
    [VehicleAttributeTypeEnum.NADA_ATTRIBUTE, 'nadaVid'],
    [VehicleAttributeTypeEnum.REDBOOK_ATTRIBUTE, 'controlNumber']
]);
//# sourceMappingURL=VehicleAttributesSectionEnum.js.map